import {isApiTrue}                 from "@Common/logic/is-api-true";
import {getSampleMailingCardError} from "@Common/logic/sample-mailing-card/get-sample-mailing-card-error";
import {cs}                        from "@Common/react/chain-services";
import {consumeContext}            from "@Common/react/context";
import {Load2}                     from "@Common/react/load2";
import {scopedState}               from "@Common/react/scoped-state";
import {scnv}                      from "@Common/react/state-change-nested-value";
import {Static2}                   from "@Common/react/static-2";
import {UseState}                  from "@Common/react/use-state";
import {cnv}                       from "@Common/utils/arr-path";
import {chain}                     from "@Common/utils/fs";
import {omit}                      from "@Common/utils/objects";

import {ErrorHighlighter} from "../../../../light/error-highlighter";
import {scrollIntoView}   from "../../../../light/scroll-into-view";

export const SampleMailingCardLogic = ({initSelected, next: rootNext}) => cs(
    consumeContext("apis"),
    consumeContext("systemConstants"),
    ["selected", (_, next) => UseState({ // If user wants to use bulk mail
        getInitValue: () => chain(
            initSelected,
            (_) => ({current: _, saved: _}),
        ),
        next,
    })],
    ["address", ({apis}, next) => Load2({
        fetch: () => apis.next.sampleAddress.getSampleAddress(),
        next,
    })],

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ["includeSampleCardCost", ({selected, systemConstants}, next) => next(
        selected.value.current && systemConstants.value?.["INCLUDE_SAMPLE_CARD_COST"] === true
    )],

    ({domRef, eh, address, selected, includeSampleCardCost, apis}) => rootNext({
        cleanItem: (item) => cnv(item, [], (_) => omit(_, ["sampleShippingAddressId"])),
        ui: {
            domRef: domRef.set,
            eh,

            address: address.value,

            selected: scopedState(selected, ["current"]),

            onChangeAddress: async (address1) => {

                const saveResult = await apis.next.sampleAddress.saveSampleAddress({
                    ...address1,
                    sampleAddressId: address.value.idPrimary,
                    mailSampleCard: 1,
                });
                if (saveResult.result === "failure") {
                    throw saveResult.errors.msg;
                }

                const cassResult = await apis.next.sampleAddress.cassSampleAddress(address.value.idPrimary);

                if (cassResult.description) {
                    address.onChange({
                        ...address.value,
                        ...address1,
                        failed: "1",
                    });
                    throw cassResult.description;
                }
                address.reload();
            },
        },
        editor: {
            $name: "sample mailing card",
            prepareSave: () => {
                const selected1 = selected.value.current && !!address.value;
                return ({
                    selected: selected1,
                    address: address.value,
                    onSaved: async () => {
                        scnv(selected, ["saved"], () => selected1);
                        await apis.next.sampleAddress.saveSampleAddress({
                            ...address.value,
                            sampleAddressId: address.value?.idPrimary,
                            mailSampleCard: selected1 ? 1 : 0,
                        });
                    },
                });
            },

            changed: selected.value.saved !== selected.value.current,

            loading: address.loading,
            valid: !selected.value.current || (
                !address.loading &&
                address.value &&
                !isApiTrue(address.value.failed) &&
                !getSampleMailingCardError(address.value)
            ),
            errorsHandling: {
                highlightErrors: () => {
                    eh.start();
                    scrollIntoView(domRef.get());
                },
            },
        },
        includeSampleCardCost
    }),
);

